import axios from 'axios'
import CONSTANTS from '~/constants'
import { setVariants } from '../../../redux/storyData'

async function fetchVariants({ dispatch, storyId, fetchedVariants = null }) {
  try {
    let response = fetchedVariants
    if (!response) {
      const variantsResponse = await axios.get(
        `${CONSTANTS.TRIDENT_ROUTE_COMPOSER_API}/v2/cc/${storyId}/variants`
      )

      response = variantsResponse.data?.variants
    }

    const variants = []

    response.map(async (variant) => {
      const variantResponse = await axios.get(
        `${CONSTANTS.TRIDENT_ROUTE_COMPOSER_API}/v2/cc/${storyId}/variant/${variant._id}`
      )
      variants.push(variantResponse.data?.variant.content?.content_elements)
    })

    dispatch(
      setVariants({
        variants: variants ?? [],
      })
    )
  } catch (error) {
    console.error(error)
    dispatch(
      setVariants({
        variants: [],
      })
    )
  }
}

export default fetchVariants
